module.exports = __webpack_public_path__ + "image/EN_News1_photo.1782790484418.jpg";